module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/add-folder.ec50c7c9.png";